import axios from 'axios';

// API URL .env dosyasından alınır
const API_URL = process.env.REACT_APP_API_URL + '/api/admin-info';

// Get admin info
const getAdminInfo = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

// DÜZELTME: Fonksiyona ikinci parametre olarak 'token' eklendi.
const updateAdminInfo = async (infoData, token) => {
  // DÜZELTME: Token'ı kullanarak Authorization başlığını oluşturan config objesi eklendi.
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // DÜZELTME: İstek, config objesi ile birlikte gönderiliyor.
  const response = await axios.put(API_URL, infoData, config);
  return response.data;
};

// YENİ: Resim yüklemek için servis fonksiyonu
const uploadAdminImage = async (uploadData, token) => { // DÜZELTME: token parametresi eklendi
  const { imageFile, field } = uploadData;

  const formData = new FormData();
  formData.append('image', imageFile); // 'image' backend'deki upload.single('image') ile eşleşmeli
  formData.append('field', field);     // 'field' backend'deki req.body.field ile eşleşmeli

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data', // Dosya yükleme için bu header zorunludur.
      Authorization: `Bearer ${token}`, // DÜZELTME: Authorization başlığı eklendi
    },
  };

  // Yeni API yoluna PUT isteği atıyoruz
  const response = await axios.put(API_URL + '/upload-image', formData, config);
  return response.data;
};


// YENİ fonksiyonu export listesine ekliyoruz
const adminInfoService = {
  getAdminInfo,
  updateAdminInfo,
  uploadAdminImage, // YENİ
};

export default adminInfoService;